import React, { useEffect, useState, FC } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import Toolbar from '@mui/material/Toolbar';
import AddIcon from '@mui/icons-material/Add';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import MDButtonRoot from "./MDButton/MDButtonRoot";
import setThemeObj from './../hooks/useThemeMUI';
import StyledBox from "./StyleBox";
import MDBoxRoot from './MDBox/MDBoxRoot';
import MDInput from './MDInput/MDInputRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';


import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';


import FormControlLabel from '@mui/material/FormControlLabel';

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import {
    GridCellParams,
    DataGrid,
    GridColDef,
    GridActionsCellItem,
    GridRowId,
    GridRowModel,
} from '@mui/x-data-grid';

import * as types from "../gql/graphql";
import { graphql } from '../gql/gql';
import { useQueryAll } from '../apolloClient';

const getAdminsQuery = gql(`
query GetAdmins($after: Cursor) {
    fs_adminsCollection(after: $after) {
        pageInfo { endCursor startCursor hasNextPage }
        edges {
          node {
            nodeId
            id
            first_name
            last_name
            email
            super
            staff
            instructor
          }
        }
      }
  }
`);

const addAdminQuery = gql(`
mutation addStaff($st: fs_adminsInsertInput!) {
    insertIntofs_adminsCollection(objects: [$st])
    { affectedCount }
  }
`);

const deleteAdminQuery = gql(`
mutation deleteStaffQuery($filter:fs_adminsFilter) {
    deleteFromfs_adminsCollection(filter: $filter) {
        affectedCount
    }
}
`);

const saveStaffQuery = gql(`
    mutation saveStaffQuery($st:fs_adminsUpdateInput!, $filter:fs_adminsFilter) {
        updatefs_adminsCollection(set:$st,  filter: $filter) {
        affectedCount
        }
    }
`);

interface EditToolbarProps {
    openModal: () => void;
}

interface AddStaffDialogProps {
    //   rowData: any; // Adjust the type according to your data structure
    //render: (open: any) => any;
    onSave: (staff: types.SaveStaffQueryMutationVariables) => void;
    onClose: () => void;
}
const AddStaffDialog: FC<AddStaffDialogProps> = ({ onSave, onClose }) => {
    // Your modal content and form for editing the row data

    const noButtonRef = React.useRef<HTMLButtonElement>(null);
    //   var staff_var: types.SaveStaffQueryMutationVariables = {st: {email:'', first_name:'', last_name:'', super:false, staff: false, instructor:false}};
    var email;
    var first_name;
    var last_name;
    var admin = false;
    var staff = false;
    var instructor = false;

    return (
        <Dialog
            maxWidth="sm"
            open={true}
            fullWidth
        >
            <MDBoxRoot theme={setThemeObj}
                component="main" display="flex"
                justifyContent="space-between"
                alignItems="baseline"
                flexDirection="column"
                pt={2}
                pb={0.5}
                px={2}
                sx={{ flexGrow: 1, width: "100%" }}
                width="100%"
            >
                <MDTypographyRoot variant="h5" px={1} py={1}>Save Staff information?
                    <CloseIcon onClick={onClose} sx={{ position: "absolute", top: "10px", right: "10px" }} /></MDTypographyRoot>
                <DialogContent dividers sx={{ width: "100%" }}>
                    <MDBoxRoot pr={1} display="flex"
                        justifyContent="flex-start"
                        alignItems="baseline"
                        flexDirection="row">
                        <MDInput
                            value={first_name}
                            label="First name"
                            onChange={(e) => {
                                first_name = e.target.value;
                            }}
                            fullWidth
                        />
                        <MDInput
                            value={last_name}
                            label="Last name"
                            onChange={(e) => {
                                last_name = e.target.value;
                            }}
                            fullWidth
                        />
                    </MDBoxRoot>
                    <MDBoxRoot pr={1}>
                        <MDInput
                            value={email}
                            variant="outlined"
                            label="Email"
                            onChange={(e) => {
                                email = e.target.value;
                            }}
                        />
                    </MDBoxRoot>
                    <MDBoxRoot px={2}>
                        <FormControlLabel control={<Checkbox onChange={(e) => admin = e.target.checked} />} label="Administrator" />
                        <br />
                        <FormControlLabel control={<Checkbox onChange={(e) => staff = e.target.checked} />} label="Staff" />
                        <br />
                        <FormControlLabel control={<Checkbox onChange={(e) => instructor = e.target.checked} />} label="Instructor" />
                    </MDBoxRoot>
                </DialogContent>
                <MDBoxRoot
                    display="flex"
                    justifyContent="center"
                    alignItems="baseline"
                    flexDirection="row"
                    gap="16px"
                    pt={2}
                    pb={0.5}
                    px={2}
                    width="100%"
                >
                    <MDButtonRoot
                        ownerState={{
                            variant: "gradient",
                            color: "info",
                            textTransform: "none",
                            circular: false,
                            iconOnly: false,
                            darkMode: false
                        }}
                        size="medium"
                        type="submit" onClick={() => {
                            onSave({ st: { email: email, first_name: first_name, last_name: last_name, super: admin, staff: staff, instructor: instructor } });
                        }}>Save</MDButtonRoot>
                    <MDButtonRoot
                        ref={noButtonRef}
                        size="medium"
                        ownerState={{ textTransform: "none", variant: "gradient", color: "warning", }}
                        onClick={onClose}>
                        Cancel
                    </MDButtonRoot>
                </MDBoxRoot>
            </MDBoxRoot>
        </Dialog>
    );
};

function AdminsList() {
    const { loading, error, data } = useQueryAll<types.Fs_AdminsEdge>({query: getAdminsQuery})
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [addAdminMutation, { data: add_data, loading: add_loading, error: add_error }] = useMutation(addAdminQuery, {
        refetchQueries: [
            'GetAdmins' // Query name
        ],
    });
    const [deleteAdminMutation, { data: del_data, loading: del_loading, error: del_error }] = useMutation(deleteAdminQuery, {
        refetchQueries: [
            'GetAdmins' // Query name
        ],
    });

    const handleAddClick = () => {
        setIsModalOpen(true);
    };

    const handleDeleteClick = (id: GridRowId) => () => {
        deleteAdminMutation({ variables: { filter: { id: { eq: id } } } })
    };

    const [saveStaffMutation, { data: save_data, loading: save_loading, error: save_error }] = useMutation(saveStaffQuery, {
        refetchQueries: [
            'GetAdmins' // Query name
        ],
    });
    const processRowUpdate = React.useCallback(
        async (newRow: GridRowModel, oldRow: GridRowModel) => {
            // Make the HTTP request to save in the backend
            if (oldRow.email == newRow.email && oldRow.first_name == newRow.first_name && oldRow.last_name == newRow.last_name) return oldRow;

            const filtered = { email:newRow.email, first_name: newRow.first_name, last_name: newRow.last_name };

            const stv: types.SaveStaffQueryMutationVariables = {
                filter: { id: { eq: oldRow.id } },
                st: filtered
            };
            saveStaffMutation({ variables: stv });


            return oldRow;
        },
        [/*save row*/],
    );


    const handleCellClick = React.useCallback(
        (params: GridCellParams, event: React.MouseEvent) => {
            if (!params.isEditable) {
                return;
            }

            // Ignore portal
            if (
                (event.target as any).nodeType === 1 &&
                !event.currentTarget.contains(event.target as Element)
            ) {
                return;
            }


            if (params.field == "super") {
                const stv: types.SaveStaffQueryMutationVariables = { filter: { id: { eq: params.id } }, st: { super: !params.value } };
                saveStaffMutation({ variables: stv });
            }
            if (params.field == "staff") {
                const stv: types.SaveStaffQueryMutationVariables = { filter: { id: { eq: params.id } }, st: { staff: !params.value } };
                saveStaffMutation({ variables: stv });
            }
            if (params.field == "instructor") {
                const stv: types.SaveStaffQueryMutationVariables = { filter: { id: { eq: params.id } }, st: { instructor: !params.value } };
                saveStaffMutation({ variables: stv });
            }
        },
        [],
    );
    {/*resizable: true,    Warning: Failed prop type: MUI: `column.resizable = true` is not a valid prop.
Column resizing is not available in the MIT version.*/}
    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'email', headerName: 'Staff Email', width: 230, editable: true },
        { field: 'first_name', headerName: 'First Name', width: 200, editable: true },
        { field: 'last_name', headerName: 'Last Name', width: 200, editable: true },
        { field: 'super', headerName: 'Admin', type: 'boolean', width: 90, editable: true },
        { field: 'staff', headerName: 'Staff', type: 'boolean', width: 90, editable: true },
        { field: 'instructor', headerName: 'Instructor', type: 'boolean', width: 90, editable: true },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {

                return [
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        className="textPrimary icons-style error"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            }
        }
    ];


    const onStaffAdd = (staff_p: types.SaveStaffQueryMutationVariables) => {
        addAdminMutation({ variables: staff_p });
        setIsModalOpen(false);
    }

    if (loading || save_loading) return (<div>Loading</div>)
    if (error) return (<div>Error</div>)

    var admins: types.Fs_Admins[] = data.map(item => item.node);


    return (
        <Grid container spacing={1}>
            <Grid item xs={11}>
                <Card>
                    <MDBoxRoot
                        component="main" px={4} py={4}
                        sx={{ flexGrow: 1, width: '100%' }}
                    >
                        <Toolbar />
                            <StyledBox theme={setThemeObj} sx={{marginTop:"30px"}}>
                                <MDButtonRoot
                                    ownerState={{
                                        size: "medium",
                                        variant: "text",
                                        color: "info",
                                        textTransform: "uppercase",
                                    }}
                                    sx={{marginBottom:'8px'}}
                                    onClick={handleAddClick} startIcon={<AddIcon />}
                                > Add staff</MDButtonRoot>
                                <DataGrid
                                    rows={admins}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page: 0, pageSize: 100 },
                                        },
                                    }}
                                    pageSizeOptions={[100]}

                                    onCellClick={handleCellClick}
                                    processRowUpdate={processRowUpdate}
                                />
                                {isModalOpen && (
                                    <AddStaffDialog onSave={onStaffAdd} onClose={() => setIsModalOpen(false)} />
                                )}
                            </StyledBox>
                    </MDBoxRoot>
                </Card>
            </Grid>
        </Grid>
    )
}
export default AdminsList;

/*slots={{
    toolbar: EditToolbar,
}}
slotProps={{
    toolbar: { openModal: () => { setIsModalOpen(true); } },
}}*/
